import React, { useState, useEffect } from "react";
import "./Focus.css";
import { useNavigate } from "react-router-dom";
import logo from "./media/logo.png";
import QRCode from "./media/qr_code.svg";
// CHANGE ANIMATION IMPORT PER FILE
import FocusAnimation from "./FocusAnimation"; 

const NAV_ITEMS = [ { label: "About Us", path: "/about", type: "page" }, { label: "Our Team", path: "/team", type: "page" }, { label: "Services", path: "/#services", type: "scroll" }, { label: "Contact", path: "/contact", type: "page" } ];

function Focus() { // CHANGE FUNCTION NAME
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleNav = (item) => {
    setMenuOpen(false);
    if (item.type === "scroll") {
        navigate("/");
        setTimeout(() => { document.querySelector(item.path.replace("/", "")).scrollIntoView({ behavior: "smooth" }); }, 100);
    } else {
        navigate(item.path);
        window.scrollTo(0, 0);
    }
  };

  return (
    <div className="App focus-page-wrapper">
      <div className={`dimming-overlay ${menuOpen ? "active" : ""}`} onClick={() => setMenuOpen(false)}></div>
      <header className={`App-header ${scrolled ? "scrolled" : ""}`}>
        <a className="logo" href="/" onClick={(e) => { e.preventDefault(); navigate("/"); }}><img src={logo} alt="Logo" className="header-logo" /></a>
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}><div className="bar"></div><div className="bar"></div><div className="bar"></div></div>
      </header>
      <nav className={`dropdown-menu ${menuOpen ? "open" : ""}`}>
        <ul>{NAV_ITEMS.map((item, i) => <li className="dropdown-item" key={i}><a onClick={() => handleNav(item)}>{item.label}</a></li>)}</ul>
      </nav>

      <section className="focus-hero">
        <div className="container">
          {/* CHANGE TITLE */}
          <h1>Focus Industry</h1> 
          <div className="focus-divider"></div>
        </div>
      </section>

      <section className="section white-bg">
        <div className="container split-layout">
          <div className="text-content">
            {/* CHANGE TEXT CONTENT */}
            <h2>Real Estate Consultancy</h2>
            <p>At Merkel & Associates Advocates, we specialize in real estate legal consultancy, offering end-to-end services for developers, investors, buyers, sellers, landlords, tenants, and management companies. Our expertise spans pre-development due diligence, statutory compliance, project financing, and conveyancing services, including document preparation, verification, and execution. We have successfully managed numerous residential and commercial projects across Kenya, ensuring seamless transitions from development to handover. Our commitment to excellence and cost-effective solutions makes us the trusted legal partner for navigating complex real estate landscapes.</p>
          </div>
          <div className="animation-content">
             <FocusAnimation /> {/* CHANGE COMPONENT */}
          </div>
        </div>
      </section>

      <footer className="App-footer">
        <div className="qr-box"><img src={QRCode} alt="QR" /></div>
        <p>© 2025 MERKEL & ASSOCIATES ADVOCATES.</p>
      </footer>
    </div>
  );
}
export default Focus;